import React from 'react'
import { getDistance } from 'geolib'
import { slugify } from '/src/util'

// @todo, remove jsx from util
export const formatStoreAddress = (address) => {
  return (
    <span>
      {address.address_line1}, {address.locality + " " + 
      address.postal_code}, {address.administrative_area}
    </span>
  )
}

export const StoreSelectorLabel = ({ name, field_mc_store_address, field_mc_store_delivery_estimate }) => {
  return (
    <div className="store-label">
      <label>{name}</label>
      {formatStoreAddress(field_mc_store_address)}
    </div>
  )
}

export const getCloestStore = (stores, position) => {
  const results = stores.map(({ field_mc_location }) => {
    return getDistance({
      latitude: position.coords.latitude,
      longitude: position.coords.longitude
    }, {
      latitude: field_mc_location.lat,
      longitude: field_mc_location.lon
    })
  })
  const closest = results.reduce((store, pos) => store < pos ? store : pos)
  const index = results.indexOf(closest)

  if (!stores[index]) {
    return stores[0]
  }

  return stores[index]
}

export const formatPath = (name) => {
  const normalised = slugify(name)
  return `/store-locator/${normalised}`
}

export const formatCategory = (name) => {
  return name.toLowerCase().includes('metalcorp') ? 'metalcorp' : 'orrcon'
}

export const formatAddress = ({ address_line1, administrative_area, locality, postal_code }) => {
  return `${address_line1}, ${locality} ${administrative_area} ${postal_code}`
}

export const formatStores = (nodes) => {
  return nodes.map(({ node }) => {
    return {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [
          node.field_mc_location.lon,
          node.field_mc_location.lat
        ]
      },
      properties: {
        storeId: node.drupal_id,
        name: node.name,
        address: formatAddress(node.field_mc_store_address),
        category: formatCategory(node.name),
        path: formatPath(node.name),
        phone: node.field_mc_store_phone_number,
        email: node.field_mc_store_email
      }
    }
  })
}